import QuoteForm from '@/components/forms/QuoteForm/QuoteForm';

interface QuoteFormBlockProps {
	data: any;
	blockId: string;
}

export default function QuoteFormBlock({ blockId, data }: QuoteFormBlockProps) {
	const showLogo = data?.show_logo ?? true;
	const showToggle = data?.show_toggle ?? true;
	const introContent = data?.intro_content;
	const showIntro = data?.show_intro ?? true;
	const showForm = data?.show_form ?? true;

	return (
		<section id={blockId} className="pb-16 md:pb-24 pt-0 bg-gray-50">
			<QuoteForm
				showLogo={showLogo}
				showToggle={showToggle}
				introContent={introContent}
				showIntro={showIntro}
				showForm={showForm}
			/>
		</section>
	);
}
